import { useSelector } from "react-redux"
import { selectGroups } from "../../../slices/groupSlice"
import { useMutateContactGroup } from './useMutateContactGroup'

export const useProcessContactGroup = () => {
  const groups = useSelector(selectGroups)

  const {
    createContactGroupMutation,
    deleteContactGroupMutation,
    updateContactGroupMutation,
  } = useMutateContactGroup()

  const registContactGroup = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    contactGroup: any,
    redirectPath: string,
  ) => {
    e.preventDefault()
    createContactGroupMutation.mutate({ contactGroup, redirectPath })
  }

  const updateContactGroup = async (
    e:
      | React.MouseEvent<HTMLButtonElement, MouseEvent>
      | React.MouseEvent<HTMLSpanElement, MouseEvent>,
    contactGroup: any,
    redirectPath: string,
  ) => {
    e.preventDefault()
    updateContactGroupMutation.mutate({ contactGroup, redirectPath })
  }

  const deleContactGroup = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    id: any,
    redirectPath: string,
  ) => {
    e.preventDefault()
    const targetGroup = groups.find((g) => g.id === id)
    if (targetGroup && targetGroup.members.length > 0) {
      alert("グループにユーザーが登録されているため、グループを削除できませんでした")
      return
    }

    deleteContactGroupMutation.mutate({ id, redirectPath })
  }

  return {
    registContactGroup,
    updateContactGroup,
    deleContactGroup,
  }
}
